import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MaterialModule } from "../../core/shared/material.module";
import { SharedComponents } from "../shared.module";

/**
 * Component representing a carousel card with interactive features.
 */
@Component({
  selector: "app-carousel-card",
  standalone: true,
  imports: [CommonModule, MaterialModule, ...SharedComponents],
  templateUrl: "./carousel-card.component.html",
  styleUrl: "./carousel-card.component.scss",
})
export class CarouselCardComponent {
  @Output() onEventEmit = new EventEmitter();

  @Input()
  data: any = {};

  @Input()
  actions: any = [];

  displayActions = false;

  /**
   * Handles the click event on the card.
   * Emits an event with the type 'view' and the associated card data.
   */
  onCardClick() {
    this.onEventEmit.emit({
      type: "view",
      params: this.data,
    });
  }

  /**
   * Triggers a specified action associated with the card.
   * Emits an event with the specified action type.
   *
   * @param {string} actionType - The type of action to trigger.
   */
  triggerAction(actionType: string) {
    this.onEventEmit.emit({
      type: actionType
    });
  }
}
